const CourseActionTypes = {
  FETCH_COURSES_START: 'FETCH_COURSES_START',
  FETCH_COURSES_SUCCESS: 'FETCH_COURSES_SUCCESS',
  FETCH_COURSES_FAILURE: 'FETCH_COURSES_FAILURE',
};

export default CourseActionTypes;
